export function validatePhoneNumber(phoneNumber) {
    return phoneNumber.replace(/\D/g, '');
}

export function validateOnlyNumber(event) {
    const keyCode = event.keyCode || event.which;
    const inputValue = event.target.value;

    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        event.preventDefault();
    }

    if (keyCode === 46 && inputValue.indexOf(".") !== -1) {
        event.preventDefault();
    }
}
